<template>
  <ion-page class="before-test">
    <img class="before-test_mask" src="@/assets/teacher_index/version5/test_mask.png" alt="" />
    <ion-header class="ion-no-border">
      <div class="navbar flex-row align-center justify-between">
        <div class="nav-icon"></div>
        <span>训后检测</span>
        <switch-font-size />
        <!--        <img
          class="nav-icon"
          :src="getBrandImageUrl('close_icon.png')"
          alt=""
          @click="onCloseThisPage"
        />-->
      </div>
    </ion-header>
    <div class="before-test_outside">
      <div class="statistic">{{ dataList.length }}个单词</div>
      <div class="before-test_page">
        <div class="word-list">
          <div
            v-for="(item, index) in dataList"
            :key="index"
            class="word-list_item flex-row justify-between align-center cursor-pointer"
            :class="{ 'choose-true': item.selected === 2, 'choose-false': item.selected === 1 }"
            @click="onShowParaphrase(index, item, $event)"
          >
            <span class="word-style flex-row align-center">
              <span class="word-style gray-color"
                ><span class="font-small-size" style="flex-shrink: 0; font-size: 1rem"
                  >{{ index + 1 }}.</span
                >&nbsp;</span
              >
              <span class="weight-600 switch-font-size"> {{ item.word }}</span>
              <span v-show="item.showParaphrase == 2" class="cnword word-style gray-color ml-3">{{
                item.paraphrase
              }}</span>
            </span>
            <div class="choose-icon flex-row align-center">
              <img
                v-if="item.selected === 0 || item.selected === 2"
                class="test-icon"
                src="@/assets/teacher_index/version5/word_false.svg"
                alt=""
                @click.stop="onClickYes(item, $event)"
              />
              <img
                v-if="item.selected === 1"
                class="test-icon"
                src="@/assets/teacher_index/version5/checked_word_false.svg"
                alt=""
                @click.stop="onClickYes(item, $event)"
              />
              <img
                v-if="item.selected === 0 || item.selected === 1"
                class="test-icon ml-3"
                src="@/assets/teacher_index/version5/word_ok.svg"
                alt=""
                @click.stop="onClickNot(item, $event)"
              />
              <img
                v-if="item.selected === 2"
                class="test-icon ml-3"
                src="@/assets/teacher_index/version5/checked_word_true.svg"
                alt=""
                @click.stop="onClickNot(item, $event)"
              />
              <!--                <img-->
              <!--                    class="test-icon ml-3"-->
              <!--                    :src="getBrandImageUrl('speed/not_play_icon.png')"-->
              <!--                    alt=""-->
              <!--                />-->
              <!--                <img-->
              <!--                    v-if="false"-->
              <!--                    class="test-icon ml-3"-->
              <!--                    :src="getBrandImageUrl('speed/playing_icon.png')"-->
              <!--                    alt=""-->
              <!--                />-->
            </div>
          </div>
          <ion-content>
            <ion-infinite-scroll
              id="infinite-scroll"
              threshold="100px"
              :disabled="isDisabled"
              @ionInfinite="loadData($event)"
            >
              <ion-infinite-scroll-content loading-spinner="bubbles" loading-text="数据加载中...">
              </ion-infinite-scroll-content>
            </ion-infinite-scroll>
          </ion-content>
        </div>
      </div>
    </div>
    <div class="before-test_bottom">
      <div class="before-test_bottom-content flex-row justify-between align-center">
        <div>
          <span
            >正确<span class="orange-color">{{ yesNum }}</span></span
          >
          <span
            >错误<span class="common-color">{{ notNum }}</span></span
          >
        </div>
        <div>
          <ion-button v-if="dataList.length" class="submit-button" shape="round" @click="doSubmit"
            >提交
          </ion-button>
          <ion-button
            v-if="closeButtonVisible"
            class="btn golden_bg"
            shape="round"
            @click="onCloseThisPage"
            >关闭
          </ion-button>
          <!--          <ion-button v-if="userinfo.account=='ztt'" class="green_bg" shape="round" @click="selectAll">全选</ion-button>-->
        </div>
      </div>
    </div>
  </ion-page>
</template>

<script>
/* eslint-disable */

import {
  actionSheetController,
  alertController,
  IonButton,
  IonButtons,
  IonCol,
  IonContent,
  IonFooter,
  IonGrid,
  IonHeader,
  IonIcon,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonItem,
  IonLabel,
  IonPage,
  IonRefresher,
  IonRefresherContent,
  IonRow,
  IonText,
  IonTitle,
  IonToolbar,
  modalController,
} from "@ionic/vue";

import { checkmarkCircle, closeCircle, library } from "ionicons/icons";
import PageWhiteBackground from "@/components/PageWhiteBackground.vue";
import CutBoxEndModal from "@/views/personal/CutBoxEndModal.vue";
import { getBrandImageUrl } from "@/js/brandImages";
import SwitchFontSize from "@/views/other/SwitchFontSize.vue";

export default {
  name: "SpeedAfterTest",
  props: ["studentId", "showCloseButton", "notForce", "currentAtmId"],
  components: {
    SwitchFontSize,
    IonInfiniteScrollContent,
    PageWhiteBackground,
    IonInfiniteScroll,
    IonPage,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonLabel,
    IonButton,
    IonButtons,
    IonItem,
    IonIcon,
    IonGrid,
    IonRow,
    IonCol,
    IonFooter,
    IonText,
    IonRefresher,
    IonRefresherContent,
  },

  setup() {
    return {
      closeCircle,
      checkmarkCircle,
      library,
    };
  },

  data() {
    return {
      isDisabled: false,
      dataList: [],
      yesNum: 0,
      notNum: 0,
      courseId: undefined,
      courseName: undefined,
      closeButtonVisible: false, //关闭按钮是否显示
      totalNum: 0,
      timeout: false,
    };
  },

  methods: {
    getBrandImageUrl,

    //关闭本页面
    onCloseThisPage() {
      modalController.dismiss();
    },

    doRefresh(refreshAnimationEvent) {
      this.tools.closeRefreshAnimation(refreshAnimationEvent, 2000);
      this.queryMyWords(refreshAnimationEvent);
    },

    //全部选择
    selectAll() {
      this.dataList.forEach((item) => {
        item.selected = 1;
      });
    },

    requestGenerateForget(params) {
      return new Promise((resolve, reject) => {
        if (!this.timeout) {
          this.timeout = true;
          setTimeout(() => {
            this.timeout = false;
          }, 500);
          if (params.aptmId == 0) {
            resolve("");
          } else {
            this.ajax
              .post("/forget/generateForget", params)
              .then(async (res) => {
                if (res.data.success) {
                  await this.alert("21天抗遗忘创建成功。");
                  resolve("");
                }
              })
              .catch(() => {
                reject("");
              });
          }
        }
      });
    },

    //显示选择资料列表
    async showTeacherSelect(aptmId) {
      return new Promise(async (resolve) => {
        let buttons = [];
        for (let i = 5; i < 24; i++) {
          let fill = i < 10 ? "0" : "";
          let time1 = fill + i + ":00";
          let time2 = fill + i + ":30";
          let params1 = { aptmId: aptmId, startTime: time1 };
          let params2 = { aptmId: aptmId, startTime: time2 };
          buttons.push({
            text: time1,
            handler: async () => {
              await this.requestGenerateForget(params1);
              resolve();
            },
          });

          buttons.push({
            text: time2,
            cssClass: "teacherSelectButtons",
            handler: async () => {
              await this.requestGenerateForget(params2);
              resolve();
            },
          });
        }
        const actionSheet = await actionSheetController.create({
          header: "选择抗遗忘时间 ",
          buttons: buttons,
          backdropDismiss: false,
        });

        await actionSheet.present();
      });
    },

    onShowParaphrase(index, item) {
      //this.playSound(item.word);
      this.playSoundTemp(item);
      for (let i = 0; i < this.dataList.length; i++) {
        if (index == i) {
          if (this.dataList[i].showParaphrase < 2) {
            this.dataList[i].showParaphrase++;
          } else {
            this.dataList[i].showParaphrase = 0;
          }
        }
      }
    },

    countSelectNum() {
      this.yesNum = 0;
      this.notNum = 0;
      for (let i = 0; i < this.dataList.length; i++) {
        if (this.dataList[i].selected == 1) {
          this.yesNum++;
        } else if (this.dataList[i].selected == 2) {
          this.notNum++;
        }
      }
    },

    //弹出"继续练习"，"结束资料"对话框
    async myAlert1(message) {
      return new Promise(async (resolve) => {
        const modal = await modalController.create({
          component: CutBoxEndModal,
          componentProps: { yesNum: this.yesNum, notNum: this.notNum },
          backdropDismiss: false,
          cssClass: "common_center_70_modal_controller_class",
        });
        await modal.present();

        modal.onDidDismiss().then((res) => {
          resolve(res.data);
        });
      });
    },

    //弹出"结束资料"对话框 强制提交的时候用。
    async myAlert2(message) {
      return new Promise(async (resolve) => {
        const alert = await alertController.create({
          header: "",
          message: message,
          backdropDismiss: false,
          buttons: [
            {
              text: "结束练习，并创建抗遗忘复习",
              handler: () => {
                resolve(true);
              },
            },
          ],
        });
        await alert.present();
      });
    },

    //提交测试结果
    submitTestData(param) {
      return new Promise((resolve) => {
        //如果是陪练自己体验上课流程，则保存体验结束时间
        const isNew = sessionStorage.getItem("isNew");
        if (this.userinfo.userType == 2 && this.studentId == this.userinfo.userId) {
          param.trialId = this.store.getTrialId();
          param.list = null;

          this.ajax.post("/trial/finishTrialClass", param).then((res) => {
            if (res.data.success) {
              resolve(false); //false为试课
            }
          });
        }

        //正常练习
        else {
          const appointment = this.store.getAppointment();
          param.courseId = appointment.courseId;
          param.masteryType = isNew === "0";
          this.ajax.post("/vocabulary/updateMastery", param).then((res) => {
            if (res.data.success) {
              resolve(true); //true为正式课
            }
          });
        }
      });
    },

    //响应提交按钮点击事件
    async doSubmit() {
      this.countSelectNum();
      for (let i = 0; i < this.dataList.length; i++) {
        if (this.dataList[i].selected == 0) {
          this.alert("存在未标记单词");
          return;
        }
      }

      const message = "正确：" + this.yesNum + ", 错误：" + this.notNum;

      let endClass = false;
      let classStatus;

      //非强制提交
      if (this.notForce) {
        const data = await this.myAlert1(message);
        if (data.hasOwnProperty("status")) {
          endClass = "TO_HOME" === data.status; // 是否是常规练习 是 返回true， 否 返回false
          classStatus = data.status;
        } else {
          endClass = data;
        }
      }
      //强制提交
      else {
        endClass = await this.myAlert2(message);
      }

      const param = {
        studentId: this.studentId,
        list: this.dataList,
        yesNum: this.yesNum,
        notNum: this.notNum,
        wordsNum: this.dataList.length,
        total: this.dataList.length,
      };

      if (this.currentAtmId) {
        param.aptmId = this.currentAtmId;
      } else {
        this.appointment = this.store.getAppointment();
        param.aptmId = this.appointment.aptmId;
      }

      //提交学后检测结果
      await this.submitTestData(param);

      //如果结束资料，则自动创建21天抗遗忘
      if (endClass) {
        await this.showTeacherSelect(param.aptmId);
        this.setPageAfterTestIsOpen(false);
        // userType=1 学生回学生首页，否则回陪练首页
        const homePath =
          Number(this.userinfo?.userType) === 1 ? "/StudentIndex" : "/TeacherIndex";
        location.replace(homePath);
      }

      //继续学习，回到九阶岛
      else {
        this.store.clearAfterTestFlag();
        this.setPageAfterTestIsOpen(false);
        await modalController.dismiss({ status: classStatus });
      }
    },

    onClickYes(item) {
      this.tools.onClickYes(item);
      this.countSelectNum();
      item.showParaphrase = item.selected === 1 ? 2 : 0;
    },

    onClickNot(item) {
      this.tools.onClickNot(item);
      this.countSelectNum();
      item.showParaphrase = item.selected === 2 ? 2 : 0;
    },

    //################################
    // 从服务器读取单词列表
    //################################
    queryMyWords(ev) {
      this.ajax
        .post(
          `/vocabulary/queryAfterTestWords?studentId=${this.studentId}&aptmId=${this.currentAtmId || ""}`
        )
        .then((res) => {
          if (res.data.success) {
            if (ev) {
              ev.target.complete();
            }
            this.courseName = res.data.courseName;
            this.courseId = res.data.courseId;
            this.dataList = [];
            for (let i = 0; i < res.data.list.length; i++) {
              res.data.list[i].selected = 0;
              res.data.list[i].showParaphrase = 0;
              this.dataList.push(res.data.list[i]);
            }

            this.dataList = res.data.list;

            if (this.dataList.length == 0) {
              this.closeButtonVisible = true;
              this.alert("未查询到用于训后检测的单词！");
            }
          }
        });
    },
  },

  mounted() {
    this.userinfo = this.store.getUser();
    this.setPageAfterTestIsOpen(true);
    this.queryMyWords();
  },
};
</script>

<style scoped lang="less">
@import "@/assets/common.less";

.before-test {
  width: 100%;
  height: 100%;
  position: relative;
  padding: 0 0 5vh;
  user-select: none;
  -webkit-user-select: none;
  background: #f2f3f6;
  z-index: 1;

  &_mask {
    position: absolute;
    right: 0;
    top: 0;
    width: 12rem;
    z-index: 2;
  }

  &_outside {
    position: relative;
    z-index: 3;
    margin: 0 auto;
    width: 95%;
    height: calc(100% - 3rem);
    background: #ffffff;
    border-radius: 0.5rem;

    .statistic {
      color: var(--font-grey-color);
      height: 2rem;
      line-height: 2rem;
      padding-left: 1rem;
    }
  }

  &_page {
    width: 100%;
    height: calc(100vh - 10rem);
    overflow-y: scroll;
    overflow-x: hidden;

    .word-list {
      &_item {
        padding: 4vw;
        border-bottom: 1px solid #eaeaea;

        .word-style {
          display: inline-block;
          font-size: var(--font-size);
          word-break: break-all;
        }

        .choose-icon {
          width: 18%;
          flex-shrink: 0;
        }
      }

      .item-checked {
        border: 1px solid var(--theme-color);
      }

      .choose-false {
        background: linear-gradient(0deg, rgba(16, 194, 139, 0.04), rgba(16, 194, 139, 0.04));
      }

      .choose-true {
        background: linear-gradient(0deg, rgba(255, 173, 0, 0.04), rgba(255, 173, 0, 0.04));
      }

      .test-icon {
        width: 1.8rem;
      }
    }

    .statistic {
      color: var(--font-grey-color);
    }
  }

  &_bottom {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 3rem;
    background-color: #ffffff;
    box-shadow: 1px 1px 2px 0 var(--font-grey-color);
    z-index: 4;
    box-sizing: border-box;

    &-content {
      flex-shrink: 0;
      height: 100%;
      padding: 0 3vw;
      color: #9a9b9c;
    }
  }

  .submit-button {
    --background: var(--theme-color);
    --box-shadow: none;
  }
}

::v-deep(.btn) {
  height: 2rem;
  width: 5rem;
}
</style>
